import { defineMessages } from 'react-intl';

export const scope = 'app.components.BestForRestaurants';

export default defineMessages({
  viewDetail: {
    id: `${scope}.viewDetail`,
    defaultMessage: 'Xem chi tiết',
  },
  sectionTitle: {
    id: `${scope}.sectionTitle`,
    defaultMessage: 'Lựa chọn hàng đầu cho nhà hàng của bạn',
  },
  1153: {
    id: `${scope}.1153`,
    defaultMessage: 'Tin dùng bởi hơn 50 tiệm bánh',
  },
  1154: {
    id: `${scope}.1154`,
    defaultMessage: 'Lựa chọn hàng đầu của đầu bếp',
  },
  1175: {
    id: `${scope}.1175`,
    defaultMessage: 'Công nghệ tiên tiến từ Nhật Bản',
  },
  1177: {
    id: `${scope}.1177`,
    defaultMessage: 'Thân thiện môi trường',
  },
  1176: {
    id: `${scope}.1176`,
    defaultMessage: 'Công nghệ tiên tiến từ Nhật Bản',
  },
  1178: {
    id: `${scope}.1178`,
    defaultMessage: 'Chứng nhận ISO 9001 và ISO 22000',
  }
});